module.exports = __webpack_public_path__ + "static/media/xenon-theme.c30703ad.wav";